import { useNavigate } from 'react-router';

/** Table row that navigates on click (links inside still work normally). */
export function RowLink({ href, children, className = '' }: { href: string; children: React.ReactNode; className?: string }) {
  const navigate = useNavigate();
  return (
    <tr
      className={`cursor-pointer ${className}`}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest('a,button,input,select,textarea')) return;
        navigate(href);
      }}
    >
      {children}
    </tr>
  );
}
